import React from "react";
import { AiFillEye } from "react-icons/ai";

const OrderTable: React.FC<any> = ({
  columns,
  data,
  onView
}) => {
  const getBgColor = (text: string) => {
    if (text === "Pending") {
      return "#fa761e";
    } else {
      return "#005ec9";
    }
  };
  return (
    <div className="mt-4">
      <div className="relative overflow-x-auto max-h-[85vh] hide-scrollbar shadow-sm overflow-auto  sm:rounded-lg">
        <table className="w-full text-sm text-left  text-gray-500 font-poppins">
          <thead className="text-xs text-white sticky top-0 uppercase  bg-gray-700 ">
            <tr>
              {columns &&
                columns.map((column: any) => (
                  <th key={column} scope="col" className="px-6 py-3">
                    {column}
                  </th>
                ))}
            </tr>
          </thead>
          <tbody className="overflow-y-auto">
            {data &&
              data.map((item: any) => (
                <tr key={item.Oid} className="odd:bg-white border-b">
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item.Oid}
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    <div className="flex gap-2 items-center">
                      <img
                        src={item.imageUrl}
                        className="w-10 h-10 border rounded-full object-cover"
                      />
                      <div>
                        <h3 className="font-poppins text-black font-semibold text-[0.9rem]">
                          {item.name}
                        </h3>
                        <h3 className="font-poppins text-black font-medium text-[0.8rem]">
                          {item.email}
                        </h3>
                      </div>
                    </div>
                  </td>

                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {new Date(item.createdDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {JSON.parse(item.products).length}
                  </td>

                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    {item.paymentMethod === "COD" ||
                    item.paymentMethod === "Cash"
                      ? "Cash on delivery"
                      : item.paymentMethod}
                  </td>
                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    £{item.total}
                  </td>

                  <td className="px-6 py-4 max-w-[15rem] h-[4rem] overflow-hidden text-ellipsis whitespace-nowrap">
                    <div
                      className="px-3 py-1 text-xs font-poppins w-fit font-medium text-white rounded-full"
                      style={{
                        backgroundColor: getBgColor(item.status),
                      }}
                    >
                      {item.status}
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex gap-4 items-center justify-center">
                      <div
                        onClick={() => onView(item)}
                        className="cursor-pointer bg-slate-200 rounded-full p-2"
                      >
                        <AiFillEye />
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderTable;
